module.exports = __webpack_public_path__ + "static/media/house.4bf41d83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Chess/RightMenu/About/house.svg
// module id = 1508
// module chunks = 0